import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ComponentClickSuggestionLink from './component-click-suggestion-link';

class ParagraphCallToAction extends Component {
  render() {
    const sectionClassNames = classNames({
      'paragraph paragraph-call-to-action': true
    });

    const { content } = this.props;

    return (
      <section className={sectionClassNames}>

        <div className="container">
          <div className="row">
            <div className="col-12 d-flex flex-column align-items-center">
              {!!content.fieldHeading &&
              <h2>{content.fieldHeading}</h2>
              }
              <ComponentClickSuggestionLink className="btn btn-primary" link={content.fieldCallToAction} />
              {!!content.fieldBeschreibung &&
              <div className="text" dangerouslySetInnerHTML={{__html: content.fieldBeschreibung.value}}/>
              }
            </div>
          </div>
        </div>

      </section>
    );
  }
}

ParagraphCallToAction.propTypes = {
  content: PropTypes.object.isRequired
};

export default ParagraphCallToAction;
